<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="8" sm="8" class="pb-0">
      <v-row>
        <v-col md="6" class="pb-0" v-if="watchUsers.length > 1">
          <ExtenSelect @filter="$emit('filter')" />
        </v-col>
        <v-col md="3" :offset-md="colOffset" class="pb-0">
          <DatePicker
            @set-date="setStart"
            :disabled="disabled"
            :max-date="endDate"
            :date="startDate"
            :label="$t('cdrs.filter.startDate')"/>
        </v-col>
        <v-col md="3" class="pb-0">
          <DatePicker
            @set-date="setEnd"
            :disabled="disabled"
            :min-date="startDate"
            :date="endDate"
            :label="$t('cdrs.filter.endDate')"/>
        </v-col>
        <v-col class="d-flex justify-end align-center" cols="1">
          <v-btn :disabled="disabled" icon @click="download">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ExtenSelect from './exten_select'
import DatePicker from './datepicker'
import { formatDateISO } from '@/filters/format_date'

export default {
  name: 'cdrs-filter-form',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: { DatePicker, ExtenSelect },
  computed: {
    ...mapGetters({
      fromDate: 'cdrs/fromDate',
      toDate: 'cdrs/toDate',
      watchUsers: 'cdrs/watchUsers'
    }),
    colOffset: function () {
      return this.watchUsers.length > 1 ? 0 : 3
    },
    startDate: function () {
      return this.fromDate || formatDateISO()
    },
    endDate: function () {
      return this.toDate || formatDateISO()
    }
  },
  methods: {
    ...mapActions({
      setStartDate: 'cdrs/setStartDate',
      setEndDate: 'cdrs/setEndDate',
      download: 'cdrs/downloadCDRsAsCSV'
    }),
    setStart: function (val) {
      this.setStartDate(val)
      this.$emit('filter')
    },
    setEnd: function (val) {
      this.setEndDate(val)
      this.$emit('filter')
    }
  }
}
</script>

<style scoped>
</style>
